import React, { useEffect, useState } from "react";
import styled from "styled-components";

const STORAGE_KEY = "sitewide-banner-dismissed";

const Wrapper = styled.div`
  width: 100%;
  height: 75px;
  background-color: ${({ theme }) => theme.primary};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 48px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1004;
  flex-shrink: 0;
`;

const Message = styled.span`
  font-size: 14px;
  text-align: center;

  a {
    color: #fff;
    text-decoration: underline;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  color: #fff;
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 4px 8px;
  opacity: 0.8;

  &:hover {
    opacity: 1;
  }
`;

const SitewideBanner = () => {
  const [banner, setBanner] = useState(null);

  useEffect(() => {
    fetch("/banner.json", { cache: "no-store" })
      .then(res => {
        if (!res.ok) return null;
        return res.json();
      })
      .then(data => {
        if (
          data &&
          data.enabled === true &&
          typeof data.message === "string" &&
          data.message.trim() &&
          localStorage.getItem(STORAGE_KEY) !== data.message
        ) {
          setBanner(data);
        }
      })
      .catch(() => {
        // Silently ignore — missing or malformed file means no banner.
      });
  }, []);

  if (!banner) return null;

  const handleClose = () => {
    localStorage.setItem(STORAGE_KEY, banner.message);
    setBanner(null);
  };

  return (
    <Wrapper>
      <Message dangerouslySetInnerHTML={{ __html: banner.message }} />
      <CloseButton onClick={handleClose} aria-label="Dismiss banner">
        &#x2715;
      </CloseButton>
    </Wrapper>
  );
};

export default SitewideBanner;
